import axios from '../../../axios';

export type ServiceResponse = {
  id: number;
  updated: string;
  created: string;
  type: string;
  body: string;
  viewCount: number;
};

export default async function getNotification(): Promise<any> {
  let res = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/notification/fleet-manager`
  );
  return res.data;
}
